export default __webpack_public_path__ + "static/media/billing-machine.4ed23ae1.png";